import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { StyleSheet } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { Container, View, H1, P } from "dripsy";
import { Fade, Button } from "../components";
import LogoSvg from "../assets/logo.svg";
export function MainScreen(param) {
    var navigation = param.navigation;
    var _useSafeAreaInsets = useSafeAreaInsets(), top = _useSafeAreaInsets.top, bottom = _useSafeAreaInsets.bottom;
    var handlePressStartButton = function() {
        navigation.navigate("Intro");
    };
    return /*#__PURE__*/ _jsxs(Container, {
        sx: {
            paddingTop: top,
            paddingBottom: bottom
        },
        children: [
            /*#__PURE__*/ _jsxs(Fade, {
                style: styles.contentArea,
                delay: 500,
                children: [
                    /*#__PURE__*/ _jsx(LogoSvg, {
                        width: 120,
                        height: 120
                    }),
                    /*#__PURE__*/ _jsx(H1, {
                        children: "React Native Esbuild"
                    }),
                    /*#__PURE__*/ _jsxs(P, {
                        style: styles.subTitle,
                        children: [
                            "⚡️ An extremely fast bundler",
                            "\n",
                            "+",
                            "\n",
                            "React Native"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Fade, {
                delay: 750,
                children: /*#__PURE__*/ _jsx(Button, {
                    label: "Getting Started",
                    onPress: handlePressStartButton
                })
            }),
            /*#__PURE__*/ _jsx(View, {
                sx: {
                    marginBottom: "$04"
                }
            })
        ]
    });
}
var styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: "white",
        padding: 16,
        justifyContent: "space-between"
    },
    contentArea: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        paddingVertical: 24,
        gap: 8
    },
    title: {
        fontSize: 30,
        fontWeight: "600",
        textAlign: "center",
        color: "#222"
    },
    subTitle: {
        fontSize: 20,
        fontWeight: "600",
        textAlign: "center",
        color: "#555"
    }
});
